import { useState } from "react";

import { PostContactMessage } from "../../../api/contact";

import { ReactComponent as Phone } from "../../../assets/images/icons/phone.svg";
import { ReactComponent as Email } from "../../../assets/images/icons/email.svg";
import { ReactComponent as LocationMarker } from "../../../assets/images/icons/location-mark.svg";

const ContactUs = ({ data }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const onChangeInput = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onSendMessage = async (event) => {
    event.preventDefault();
    console.log(event.target.name.value);

    const response = await PostContactMessage({
      name: event.target.name.value,
      email: event.target.email.value,
      phone: event.target.phone.value,
      message: event.target.message.value,
    });

    console.log({
      name: event.target.name.value,
      email: event.target.email.value,
      phone: event.target.phone.value,
      message: event.target.message.value,
    });
    console.log(response);
  };

  return (
    <div className="h-screen mb-130 md:-mb-80 lg:mb-60 xl:mb-0 w-4/5 md:w-3/4 mx-auto">
      <h2 className="text-4xl xl:text-5xl mt-4 md:mt-10 xl:mt-20 text-blue-850">
        Contact Us
      </h2>
      <h4 className="text-lg xl:text-xl my-5">{data?.description}</h4>

      <div className="flex flex-col md:flex-row">
        <form onSubmit={(e) => onSendMessage(e)} className="md:w-2/3">
          <div className="grid mb-3 md:w-3/4">
            <label className="text-lg md:text-base" htmlFor="name">
              Name
            </label>
            <input
              onChange={onChangeInput}
              value={formData.name}
              type="text"
              name="name"
              id="name"
              placeholder="Name"
              className="border border-blue-850 shadow-md py-1 px-3"
            />
          </div>

          <div className="grid mb-3 md:w-3/4">
            <label className="text-lg md:text-base" htmlFor="phone">
              Phone Number
            </label>
            <input
              onChange={onChangeInput}
              value={formData.phone}
              type="text"
              name="phone"
              id="phone"
              placeholder="Phone Number"
              className="border border-blue-850 shadow-md py-1 px-3"
            />
          </div>

          <div className="grid mb-3 md:w-3/4">
            <label className="text-lg md:text-base" htmlFor="email">
              Email
            </label>
            <input
              onChange={onChangeInput}
              value={formData.email}
              type="text"
              name="email"
              id="email"
              placeholder="Email"
              className="border border-blue-850 shadow-md py-1 px-3"
            />
          </div>

          <div className="grid mb-3 md:w-3/4">
            <label className="text-lg md:text-base" htmlFor="message">
              Message
            </label>
            <textarea
              onChange={onChangeInput}
              value={formData.message}
              rows={4}
              name="message"
              id="message"
              placeholder="Message"
              className="border border-blue-850 shadow-md py-1 px-3"
            ></textarea>
          </div>

          <div className="md:w-3/4 flex justify-end mt-10">
            <button className="px-2 py-1 text-white bg-blue-950 " type="submit">
              Send Message
            </button>
          </div>
        </form>

        <div className="mt-6 md:mt-0">
          <div className="flex items-baseline">
            <Phone alt="Phone" className="w-10 mr-2 fill-blue-850 p-1" />

            <div>
              <p className="uppercase text-sm opacity-80 text-blue-850">
                Phone
              </p>
              {data?.phones?.map((phone) => (
                <p
                  key={phone}
                  className="opacity-90 text-black text-xl md:text-base"
                >
                  +0964{phone}
                </p>
              ))}
            </div>
          </div>

          <div className="flex items-baseline">
            <Email
              alt="Email"
              className="w-10 mr-2 fill-blue-850 text-black p-1"
            />

            <div>
              <p className="uppercase text-sm opacity-80 text-blue-850">
                Email
              </p>
              {data?.emails.map((email) => (
                <p key={email} className="opacity-90 text-black">
                  {email}
                </p>
              ))}
            </div>
          </div>

          {data?.addresses?.length !== 0 && (
            <div className="mt-7">
              <h4 className="text-blue-850 uppercase text-lg">
                Visit Our Company
              </h4>
              {data?.addresses?.map((address) => (
                <p key={address} className="opacity-90 flex items-center">
                  <LocationMarker className="-ml-3 lg:ml-0 p-3 fill-blue-850" />{" "}
                  {address}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
